import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { priceList } from '../data/mock';

const PricingSection = ({ onEnquireClick }) => {
  return (
    <section id="pricing" className="py-16 sm:py-24 bg-[#0a1628]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-10 sm:mb-16">
          <span className="text-[#c9a961] text-xs sm:text-sm font-semibold tracking-widest uppercase">Investment</span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mt-2 sm:mt-3 mb-4 sm:mb-6">Price List</h2>
          <div className="w-20 sm:w-24 h-1 bg-gradient-to-r from-transparent via-[#c9a961] to-transparent mx-auto mb-4 sm:mb-6" />
          <p className="text-white/60 text-sm sm:text-base max-w-2xl mx-auto px-4">Transparent pricing for your dream home.</p>
        </div>

        {/* Pricing Cards */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-6">
          {priceList.map((item, index) => (
            <div
              key={index}
              className="group relative bg-gradient-to-b from-white/5 to-white/[0.02] backdrop-blur-sm border border-white/10 rounded-2xl sm:rounded-3xl p-4 sm:p-8 hover:border-[#c9a961]/50 transition-all duration-500 overflow-hidden"
            >
              <div className="relative z-10">
                {/* Type Badge */}
                <div className="inline-flex items-center justify-center bg-gradient-to-r from-[#c9a961] to-[#a08545] rounded-full px-3 sm:px-4 py-1 mb-4 sm:mb-6">
                  <span className="text-[#0a1628] font-bold text-xs sm:text-sm">{item.type}</span>
                </div>

                {/* Size */}
                <div className="mb-4 sm:mb-6">
                  <p className="text-white/50 text-xs sm:text-sm mb-1">Size</p>
                  <p className="text-white text-sm sm:text-xl font-semibold">{item.size}</p>
                </div>

                {/* Price */}
                <div className="mb-4 sm:mb-8">
                  <p className="text-white/50 text-xs sm:text-sm mb-1">Starting Price</p>
                  <p className="text-xl sm:text-3xl font-bold text-[#c9a961]">₹{item.price}</p>
                </div>

                {/* CTA Button */}
                <Button
                  onClick={onEnquireClick}
                  className="w-full bg-white/10 hover:bg-[#c9a961] text-white hover:text-[#0a1628] border border-white/20 hover:border-[#c9a961] rounded-full py-3 sm:py-6 font-semibold text-xs sm:text-base transition-all duration-300"
                >
                  <span className="hidden sm:inline">Unlock Offers</span>
                  <span className="sm:hidden">Enquire</span>
                  <ArrowRight className="w-3 h-3 sm:w-4 sm:h-4 ml-1 sm:ml-2 inline-block" />
                </Button>
              </div>
            </div>
          ))}
        </div>

        <p className="text-center text-white/40 text-xs sm:text-sm mt-6 sm:mt-10">
          * Prices are subject to change. Contact us for latest pricing.
        </p>
      </div>
    </section>
  );
};

export default PricingSection;
